import {
  ReportSummary,
  BacteriaClassification,
  DisruptiveBacteria,
  BacteriaAttentionCategory,
  BacteriaAttentionAction,
  BacteriaReport,
} from '@snapi/types';
import { ReportComparatorUtils } from './report-comparator-utils';

const extract = (bacteria: BacteriaReport[]): DisruptiveBacteria[] =>
  bacteria
    .filter(
      ({ threshold: { classification, threshold, comparator }, percentage }) =>
        classification === BacteriaClassification.disruptive &&
        ReportComparatorUtils.passesThreshold(percentage, comparator, threshold)
    )
    .map<DisruptiveBacteria>(
      ({
        threshold: {
          threshold,
          comparator,
          research: { name, taxonomy },
        },
        percentage,
      }) => ({
        name,
        taxonomy,
        percentage,
        threshold: threshold,
        comparator,
        category: BacteriaAttentionCategory.disruptive,
        action:
          comparator === '<'
            ? BacteriaAttentionAction.increase
            : BacteriaAttentionAction.decrease,
      })
    )
    .sort((a, b) => b.percentage / b.threshold - a.percentage / a.threshold)
    .slice(0, 3);

const isGood = (bacteria: DisruptiveBacteria[]) => bacteria.length < 3;

const summary = (bacteria: BacteriaReport[]): ReportSummary['disruptive'] => {
  const disruptive = extract(bacteria);

  return {
    bacteria: disruptive,
    good: isGood(disruptive),
  };
};

export const ReportDisruptiveBacteriaUtils = {
  isGood,
  extract,
  summary,
};
